import React from "react"
import { X } from "lucide-react"
import { Button } from "./ui/Button"

export default function ProductDetailPopup({ isOpen, onClose, onRequestQuotation, product }) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-[#FBF1EB] rounded-lg w-full max-w-lg sm:max-w-md md:max-w-sm relative">
        <Button
          onClick={onClose}
          className="absolute top-2 right-2 z-10 bg-[#D9CCBE] p-1 rounded-full"
          aria-label="Close modal"
        >
          <X size={24} className="text-[#34302B]" />
        </Button>



        <div className="p-4 sm:p-6 flex flex-col items-center">
          <div className="w-full aspect-square relative mb-4">
            <img
              src={product.image || "/placeholder.svg"}
              alt={product.name}
              className="object-cover rounded-md w-full h-full"
              style={{ aspectRatio: "1 / 1" }}
            />
          </div>

          <h2 className="text-xl sm:text-2xl font-serif text-center text-[#34302B] mb-4">
            {product.name}
          </h2>

          <p className="text-base sm:text-lg text-center text-[#34302B] mb-6">
            {product.description}
          </p>

          {product.hexCode && (
            <div className="bg-[#D9CCBE] px-4 py-2 mb-6 rounded">
              <p className="text-[#34302B] text-sm">HSN CODE - {product.hexCode}</p>
            </div>
          )}

          <Button
            onClick={onRequestQuotation}
            className="bg-[#73340E] hover:bg-[#C09670] text-white px-6 sm:px-8 py-2"
          >
            Request Quotation
          </Button>
        </div>
      </div>
    </div>
  )
}
